export default __webpack_public_path__ + "static/media/sun-part-most.95544673.svg";